import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyResultComponent } from '../../../shared/components/empty-result/empty-result.component';
import {
  LoadingTableShimmerComponent,
  ShimmerColumn,
} from '../../../shared/components/loading-table-shimmer/loading-table-shimmer.component';
import { RewardsHistoryColumn, RewardsHistoryItemV2 } from '../../models/rewards-v2.models';
import { formatShortDate } from '../../../shared/utils/date.util';
import {
  formatRewardsTableCurrency,
  getRuleAmount,
  getRuleCount,
  ruleAmountColumnHeader,
  ruleCountColumnHeader,
} from '../../utils/rewards-table-display.util';

@Component({
  selector: 'app-rewards-history-table-v2',
  standalone: true,
  imports: [CommonModule, EmptyResultComponent, LoadingTableShimmerComponent],
  templateUrl: './rewards-history-table-v2.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./rewards-history-table-v2.component.scss'],
})
export class RewardsHistoryTableV2Component {
  @Input() columns: RewardsHistoryColumn[] = [];
  @Input() items: RewardsHistoryItemV2[] = [];
  @Input() loading = false;

  readonly ruleCountColumnHeader = ruleCountColumnHeader;
  readonly ruleAmountColumnHeader = ruleAmountColumnHeader;
  readonly formatRewardsTableCurrency = formatRewardsTableCurrency;
  readonly getRuleCount = getRuleCount;
  readonly getRuleAmount = getRuleAmount;

  get shimmerColumns(): ShimmerColumn[] {
    const base: ShimmerColumn[] = [
      { label: 'Date', width: 'sm' },
      { label: 'Total Rewards', width: 'md' },
    ];
    for (const column of this.columns) {
      base.push({ label: ruleCountColumnHeader(column), width: 'sm' });
      base.push({ label: ruleAmountColumnHeader(column), width: 'sm' });
    }
    return base.length > 2
      ? base
      : [
          { label: 'Date', width: 'sm' },
          { label: 'Total Rewards', width: 'md' },
          { label: 'Rule', width: 'sm' },
          { label: 'Rule Rewards', width: 'sm' },
        ];
  }

  formatDate(dateString: string): string {
    return formatShortDate(dateString);
  }

  trackByRuleId(_: number, column: RewardsHistoryColumn): string {
    return column.rule_id;
  }

  trackByDate(_: number, item: RewardsHistoryItemV2): string {
    return item.date;
  }
}
